
export default function StatsSection() {
  const stats = [
    { number: '4+', label: 'Yıl Deneyim', icon: 'ri-time-line' },
    { number: '200+', label: 'Başarılı Dava', icon: 'ri-trophy-line' },
    { number: '500+', label: 'Memnun Müvekkil', icon: 'ri-user-heart-line' },
    { number: '24/7', label: 'Destek', icon: 'ri-customer-service-2-line' }
  ];

  return (
    <section className="py-16 bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl font-bold mb-4 font-poppins">
            Rakamlarla Başarımız
          </h2>
          <div className="w-16 h-0.5 bg-white mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="text-center animate-fade-in-up hover-lift"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold mb-2 font-poppins">
                {stat.number}
              </div>
              <div className="text-gray-300 font-poppins font-light">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
